import { createSlice } from "@reduxjs/toolkit";
import { EnquireModalState } from "../../interfaces/connected-components/enquireModal";

const initialState: EnquireModalState = {
  isVisible: false,
};

/**
 * Redux slice for managing enquire modal state.
 */
export const enquireModalSlice = createSlice({
  name: "enquireModal",
  initialState,
  reducers: {
    /**
     * Action to show enquire modal.
     * @param {EnquireModalState} state - Current enquire modal state.
     */
    showEnquireModal: (state: EnquireModalState) => {
      state.isVisible = true;
    },
    /**
     * Action to hide enquire modal.
     * @param {EnquireModalState} state - Current enquire modal state.
     */
    hideEnquireModal: (state: EnquireModalState) => {
      state.isVisible = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const { showEnquireModal, hideEnquireModal } = enquireModalSlice.actions;

export default enquireModalSlice.reducer;
